import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';
import { TicketTextRegular, TicketTextBold } from 'components/common/fontElements';
import { Root as TranslationInfo } from 'components/Messages/TranslationInfo/TranslationInfo.styles';

export const WhiteSpaceNormalizeWrapper = styled(TicketTextRegular)`
  white-space: normal;

  .label {
    white-space: normal;
  }
`;

export const ShowHiddenContentComponent = styled.div`
  width: 100%;
  cursor: pointer;
  bottom: 3px;
  right: 10px;
  position: absolute;
  display: flex;
`;

export const Icon = styled.div`
  position: absolute;
  right: 10px;
  bottom: 3px;
`;

export const TicketTextBoldBlue = styled(TicketTextBold)`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  cursor: pointer;
  font-size: 10px;
  position: absolute;
  bottom: 3px;
  right: 30px;
  line-height: 18px;
  text-align: right;

  color: ${colors.blue1};
`;

export const TicketTextBoldGray = styled(TicketTextBold)`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  cursor: pointer;
  font-size: 10px;
  position: absolute;
  bottom: 3px;
  right: 30px;
  line-height: 18px;
  text-align: right;

  color: ${colors.darkGray1};
`;

export const InlineBlockComponent = styled.div`
  display: inline-flex;
  line-height: 1;
  align-items: center;
`;

export const EmailMessageBox = styled.div`
  display: flex;
  padding: 12px 16px 14px;
  border-bottom: 1px solid ${colors.lightGray15};
  white-space: pre-wrap;
  position: relative;
  animation-name: fadeIn;
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
  opacity: 0%;

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }

  ${TranslationInfo} {
    position: absolute;
    inset: auto 16px 8px auto;
  }
`;

export const HiddenContentButton = styled.div`
  display: flex;
  padding: 20px 20px 20px 20px;
  border-bottom: 1px solid ${colors.lightGray6};
  white-space: pre-wrap;
  position: relative;
  background-color: ${(props) => (props.showHiddenContent ? colors.lightGray7 : '')};
  padding: 0px !important;
  border-bottom: ${(props) => (props.showHiddenContent ? 'none !important' : '')};
  height: 30px;
`;

export const HiddenContentBox = styled.div`
  display: flex;
  padding: 20px 20px 20px 20px;
  border-bottom: 1px solid ${colors.lightGray6};
  white-space: pre-wrap;
  position: relative;
  background-color: ${colors.lightGray7};
`;

export const HiddenContentText = styled.div`
  display: flex;
  flex-direction: column;
  white-space: pre-wrap;
`;

export const MessageContent = styled.div`
  width: calc(100% - 100px) !important;
`;

export const EmailSentStatusMarker = styled.div`
  padding-right: 10px;
  margin-right: 10px;
  border-right: 1px solid ${colors.lightGray2};
  font-size: 10px;
  white-space: normal;
  display: inline-block;
  font-size: 7px;
  line-height: 7px;
  color: ${(props) => (props.color ? props.color : colors.lightGray2)};
`;

export const MessageHeader = styled.div`
  justify-content: space-between;
  flex-direction: row;
  display: flex;
  font-size: 11px;
  color: ${colors.lightBlack};
  font-family: 'Lato-Light', sans-serif;
  margin-bottom: 0.8rem;
`;

export const MessageBody = styled.div`
  width: calc(100% - 25px);
  color: ${colors.lightBlack};
  font-size: 14px;
  position: relative;
  display: flex;
  flex-direction: column;
  font-family: 'Lato-Light', sans-serif;
  word-wrap: break-word;
  overflow-wrap: break-word;
  padding-left: 10px;

  & > div {
    width: 100%;
  }

  & img {
    max-width: 100%;
    max-height: 350px;
    border-radius: 10px;
  }

  @media (max-width: 1366px) {
    font-size: 12px;
  }

  img,
  p {
    &:last-child {
      margin-bottom: 0px !important;
    }
  }
`;

export const SMBReplyMessageBody = styled(TicketTextRegular)`
  font-size: 9px;
  color: ${colors.lightBlack};
  margin: ${(props) => (props.isLiveChat ? '0px 30px 0px 10px' : '0px 0px 0px 15px')};
  margin-left: 15px;
`;
